import { useEffect, useRef, useState } from 'react';
import InvoiceSplitView from '@/components/Templates/InvoiceSplitView';
import { getInvoiceStatus, statusInvoices } from '@/components/Templates/Invoices/invoices';
import { useTutorialActive } from '@/hooks/tutorialsHooks/useTutorialActive';
import { useTourContext } from '@/store/tourContext';
import type { Invoice } from '@/types/invoice';
import { generateMockInvoiceData } from '@/utils/tutorials/mockData/invoicesMockData';
import tutorialInvoice from '@/utils/tutorials/mockData/tutorial-invoice.pdf';

/**
 * Demo version of InvoiceViewModal for tutorial purposes.
 * Uses mocked data and doesn't make API calls.
 * Matches the real View Invoices modal structure with InvoiceSplitView.
 */
const DemoInvoiceViewModal = () => {
	const { registerElement } = useTourContext();
	const { 
		isAnyInvoiceOrOnboardingTutorialActive: isAnyInvoiceTutorialActive,
	} = useTutorialActive();

	const modalRef = useRef<HTMLDivElement | null>(null);
	const [fileUrl] = useState<string>(tutorialInvoice);
	
	const [mockInvoices] = useState<Invoice[]>(() => generateMockInvoiceData(3));
	const [activeInvoice, setActiveInvoice] = useState<Invoice>(mockInvoices[0]);

	useEffect(() => {
		if (!isAnyInvoiceTutorialActive) {
			registerElement('InvoicesViewModalRef', null);
			return;
		}

		const timeoutId = setTimeout(() => {
			if (modalRef.current) {
				registerElement('InvoicesViewModalRef', modalRef.current);
			}
		}, 200);

		return () => {
			clearTimeout(timeoutId);
			if (!isAnyInvoiceTutorialActive) {
				registerElement('InvoicesViewModalRef', null);
			}
		};
	}, [isAnyInvoiceTutorialActive, registerElement]);

	const handleInvoiceClick = (invoice: Invoice) => {
		setActiveInvoice(invoice);
	};

	return (
		<div ref={modalRef}>
			<InvoiceSplitView
				invoices={mockInvoices}
				activeInvoice={activeInvoice}
				getStatus={(invoice) =>
					getInvoiceStatus(statusInvoices(invoice)?.toLowerCase())
				}
				onInvoiceClick={handleInvoiceClick}
				isLoadingPDF={false}
				pdfUrl={fileUrl}
			/>
		</div>
	);
};

export default DemoInvoiceViewModal;

